import React, { useState } from 'react'
import { SupabaseFunctionsService } from '../services/supabaseFunctionsService'

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  })
  const [errors, setErrors] = useState({})
  const [notification, setNotification] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }))
    }
  }

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  const validateField = (name, value) => {
    if (!value.trim()) {
      return 'This field is required'
    }
    if (name === 'email' && !validateEmail(value)) {
      return 'Please enter a valid email address'
    }
    return ''
  }

  const showNotification = (message, type = 'info') => {
    setNotification({ message, type })
    setTimeout(() => setNotification(null), 5000)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    // Validate all fields
    const newErrors = {}
    Object.keys(formData).forEach(key => {
      const error = validateField(key, formData[key])
      if (error) {
        newErrors[key] = error
      }
    })

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      showNotification('Please fill in all fields correctly', 'error')
      return
    }

    setIsSubmitting(true)
    
    try {
      // Submit contact message to backend
      const result = await SupabaseFunctionsService.submitContactMessage(formData)
      
      if (result.success) {
        showNotification('Thank you for your message! We\'ll get back to you soon.', 'success')
        setFormData({ name: '', email: '', message: '' })
        setErrors({})
      } else {
        showNotification(result.error || 'Failed to send message. Please try again.', 'error')
      }
    } catch (error) {
      console.error('Contact form submission error:', error)
      showNotification('An unexpected error occurred. Please try again.', 'error')
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleNavClick = (e, targetId) => {
    e.preventDefault()
    const target = document.querySelector(targetId)
    if (target) {
      const offsetTop = target.offsetTop - 70
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      })
    }
  }

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="contact-content">
          <div className="contact-header">
            <h2>Contact Us</h2>
          </div>
          {/* <div className="contact-info">
            <h2>Begin Your Journey</h2>
            <p>Ready to transform your life and discover your inner truth? We're here to support you every step of the way.</p>
            <div className="contact-details">
              <div className="contact-item">
                <i className="fas fa-envelope"></i>
                <span>hello@groundedtrip.com</span>
              </div>
              <div className="contact-item">
                <i className="fas fa-phone"></i>
                <span>+1 (555) 123-4567</span>
              </div>
              <div className="contact-item">
                <i className="fas fa-map-marker-alt"></i>
                <span>Sacred Valley, Peru</span>
              </div>
            </div>
          </div> */}
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input 
                type="text" 
                id="name" 
                name="name" 
                placeholder="Your Name" 
                value={formData.name}
                onChange={handleInputChange}
                className={errors.name ? 'error' : ''}
                required 
              />
              {errors.name && <div className="field-error">{errors.name}</div>}
            </div>
            <div className="form-group">
              <input 
                type="email" 
                id="email" 
                name="email" 
                placeholder="Your Email" 
                value={formData.email}
                onChange={handleInputChange}
                className={errors.email ? 'error' : ''}
                required 
              />
              {errors.email && <div className="field-error">{errors.email}</div>}
            </div>
            <div className="form-group">
              <textarea 
                id="message" 
                name="message" 
                placeholder="Send us a message..." 
                rows="5" 
                value={formData.message}
                onChange={handleInputChange}
                className={errors.message ? 'error' : ''}
                required
              ></textarea>
              {errors.message && <div className="field-error">{errors.message}</div>}
            </div>
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i>
                  Sending...
                </>
              ) : (
                <>
                  <i className="fas fa-paper-plane"></i>
                  &nbsp; Send Message
                </>
              )}
            </button>
          </form>
        </div>
      </div>
      
      {notification && (
        <div 
          className={`notification notification-${notification.type}`}
          style={{
            position: 'fixed',
            top: '90px',
            right: '20px',
            padding: '1rem 1.5rem',
            borderRadius: '8px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
            zIndex: 10000,
            transform: 'translateX(0)',
            transition: 'transform 0.3s ease',
            maxWidth: '400px',
            color: 'white'
          }}
        >
          <div className="notification-content">
            <span className="notification-message">{notification.message}</span>
            <button 
              className="notification-close"
              onClick={() => setNotification(null)}
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </section>
  )
}

export default Contact
